var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoveUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3001 4.7999C8.3001 5.84924 7.44944 6.6999 6.4001 6.6999C5.35076 6.6999 4.5001 5.84924 4.5001 4.7999C4.5001 3.75056 5.35076 2.8999 6.4001 2.8999C7.44944 2.8999 8.3001 3.75056 8.3001 4.7999ZM6.4001 9.2999C8.60579 9.2999 10.4236 10.9606 10.6713 13.0999H2.12886C2.37658 10.9606 4.1944 9.2999 6.4001 9.2999ZM10.1001 7.1999C10.1001 7.03422 10.2344 6.8999 10.4001 6.8999H13.6001C13.7658 6.8999 13.9001 7.03422 13.9001 7.1999C13.9001 7.36559 13.7658 7.4999 13.6001 7.4999H10.4001C10.2344 7.4999 10.1001 7.36559 10.1001 7.1999Z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveUser);
export default __webpack_public_path__ + "static/media/remove-user.64302d909ffa164e87ad904c8b4ec030.svg";
export { ForwardRef as ReactComponent };